// Composes multiple providers into a single provider

interface Props {
    providers: Array<React.JSXElementConstructor<React.PropsWithChildren<any>>>
    children: React.ReactNode
}

const Compose = (props: Props) => {
    const { providers = [], children } = props

    return (
        <>
            {providers.reduceRight((acc, Comp) => {
                return <Comp>{acc}</Comp>
            }, children)}
        </>
    )
}

export default Compose
